var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-row align-items-center" }, [
    _c("div", { staticClass: "col-auto" }, [
      _c("div", [_vm._v("total:" + _vm._s(_vm.data.count))])
    ]),
    _c(
      "div",
      { staticClass: "col-auto" },
      [
        _c(
          "b-btn",
          {
            staticClass: "btn-xs",
            attrs: { variant: "outline-info mr-2" },
            on: {
              click: function($event) {
                return _vm.first()
              }
            }
          },
          [_vm._v("<<")]
        )
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "col-auto" },
      [
        _c(
          "b-btn",
          {
            staticClass: "btn-xs",
            attrs: { variant: "outline-info mr-2" },
            on: {
              click: function($event) {
                return _vm.prev()
              }
            }
          },
          [_vm._v("Prev")]
        )
      ],
      1
    ),
    _c("div", { staticClass: "col-auto" }, [
      _c("div", [
        _vm._v(
          _vm._s(_vm.data.params.page) +
            " / " +
            _vm._s(Math.ceil(_vm.data.count / _vm.data.params.limit))
        )
      ])
    ]),
    _c(
      "div",
      { staticClass: "col-auto" },
      [
        _c(
          "b-btn",
          {
            staticClass: "btn-xs",
            attrs: { variant: "outline-info mr-2" },
            on: {
              click: function($event) {
                return _vm.next()
              }
            }
          },
          [_vm._v("Next")]
        )
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "col-auto" },
      [
        _c(
          "b-btn",
          {
            staticClass: "btn-xs",
            attrs: { variant: "outline-info mr-2" },
            on: {
              click: function($event) {
                return _vm.last()
              }
            }
          },
          [_vm._v(">>")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }